import { Component, OnInit,ViewChild,QueryList ,ElementRef} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalPromptComponent } from '../../../../_helpers/Modals/prompt/modal.prompt';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { FileUploader } from 'ng2-file-upload';  
import { MustMatch } from '../../../../_helpers/must-match-validator';  
import { ModalPromptEntityComponent } from '../../../../_helpers/Modals/prompt-entity/modal.prompt-entity';

export interface indCategory {   
	value: string;
	viewValue: string;
}
export interface telelistitem {
	value: string;
	viewValue: string;
}
export interface nonGovSectorList { 
	value: string;
	viewValue: string;
}

export interface sectorlist {
	value: string;
	viewValue: string;
}

export interface selectedCountry {
	id: string;
	name: string;
}

export interface selectedState {
	id: string;
	name: string;
	country_id: string
}
export interface selectedCity {
	id: string;
	name: string;
	state_id: string;
}
export interface poilist {
	value: string;
	viewValue: string;
}

export interface poalist {
	value: string;
	viewValue: string;
}

export interface poazlist {
	value: string;
	viewValue: string;
}
export interface poazidlist {
	value: string;
	viewValue: string;
}

@Component({
	selector: 'app-common-registration', 
	templateUrl: './tmpe-common-registration-02.component.html',
	styleUrls: ['./tmpe-common-registration-02.component.css']
})
export class TMPECommonRegistrationComponent02 implements OnInit { 


	UrnFromURL: any;
	//Common_ID: any
	details: any;
	peFlag: boolean = false; 
	tmFlag: boolean = false;
	taFlag: boolean = false;
	entityForm: FormGroup;
	radiocheckshow: boolean=true;
	regEClass: any;
	showSumbit: boolean = false;
	isSEBI: boolean = false
	Entity_Other_Doc: any;
	Entity_POI_Doc: any; 
	Entity_POA_Doc: any;
	Entity_SEBI_Doc: any;
	Entity_GST_Doc: any;
	Entity_POAZ_Doc: any; 
	Entity_POAZID_Doc: any; 
	Entity_Ref_No: any 
	Registered_Operator: any 
	public modalRef: BsModalRef; 
	returnedValue: any;
	btndisabled: boolean =false;
	
	taFlaghide:boolean=true;
	tmCheckedradio:boolean=false;
	peCheckedradio:boolean=false;
	myfileotherDuplicate:any=[]


	constructor(private fb: FormBuilder,
		//private ls: APILoginService,
		private modalService: BsModalService,
		private es: APIEntityService,
		private $modal: $ModalManagerService,
		private db: $DBManagerService,
		private _route: ActivatedRoute,
		private router: Router) {
		this._route.params.subscribe((params) => {
			this.UrnFromURL = params['urn'];
		})
	}
	poilistitems: any[] = [];
	poazlistitems: any[] = [];
	poazidlistitems: any[] = [];
	TM_Type: any;
	indListItems: any[] = [];
	sectorlist: any;
	selectedCountryId: any;
	selectedStateId: any;
	newlistitems: any = [];
	newstatelistitems: any = [];
	pantanno: any;
	address1: any;
	poilist: any;
	poazlist: any;
	poazidlist: any;
	allowedExtensions: any;
	fileExtension: any;
	fileExtensionError: boolean = false;
	myfiles: any[] = [];
	myfilessebi: any[] = [];
	myfilespoi: any[] = []; 
	myfilespoa: any[] = [];
	myfilesgst: any[] = [];
	myfilespoaz: any[] = []; 
	myfilespoazid: any[] = []; 
	myfilesother: any[] = [];
	photoName: any;
	fileSizeError1: boolean = false;
	fileSizeError2: boolean = false;
	fileExtensionMessage: any;
	photoContent: any;
	showPAN: boolean = false;
	showTAN: boolean = false;
	selectpoi: any;
	POItype:any;
	selectedpoi: string;
	selectpoaz: any;
	POAZtype:any;
	selectedpoaz: string;
	selectpoazid: any;
	POAZIDtype:any;
	selectedpoazid: string;
	poalist: any;	
	public poashow: boolean = false;
	public poashowone: boolean = false;
	public poashowtwo: boolean = false;
	public poashowthree: boolean = false;
	public otherdivshow: boolean = false;
	public poazshow: boolean = false;
	public poazidshow: boolean = false;
	public othersectorshow: boolean = false;
	public otherindtypeshow: boolean = false;
	selectpoa: any;
	checked: boolean = true;
	interests = [];
	public teledroplist: boolean = false;
	emailId: any;
	pancard: any;
	mobile: any;
	industryCategory: any;
	myFiless: string[] = [];
	files: any[] = [];
	entities = [];
	existEntityFlag: boolean = false;
	public industryCategoryshow: boolean = false;
	public gstdivinfoshow: boolean = false;
	public othersFlag: boolean = false;
	public emailmobotp: boolean = false;
	public pwdcpwd: boolean = false;
	public TAN = false;
	public PAN = true;
	public selpriv = true;
	public selgov;
	public errormsg;
	public selectedpantanno;
	public regopdiv: boolean = false;
	public regopdivno: boolean = false;
	gstidinfo: any;
	PiList: any;
	getotherid: any;
	otpEExp: any;
	otpMExp: any;
	otpEmail: any;
	otpMobile: any;
	disabled: boolean = false;
	selectedPE: boolean = false;
	selectedTM: boolean = false;
	selectedTA: boolean = false;
	public peChecked: boolean = false;
	public tmChecked: boolean = false;
	public taChecked: boolean = false;
	public orgReadOnly: boolean = false;
	public poiReadOnly: boolean=false;
	public poazReadOnly: boolean=false;
	public poazidReadOnly: boolean=false;
	isNumCheckadres1:boolean=false;
	isNumCheckadres2:boolean=false;
	isNumOrgName:boolean=false;
	public hideSector:boolean = false;
	public poifileExtensionError: boolean = false
	public poafileExtensionError: boolean = false
	public poazfileExtensionError: boolean = false
	public poazidfileExtensionError: boolean = false
	public sebifileExtensionError: boolean = false
	public gstfileExtensionError: boolean = false
	public otherfileExtensionError: boolean = false
	Entity_Other_Doc1: any

	
	fileuploadpoiMax: boolean = false 
	fileuploadpoiMin: boolean = false
	fileuploadpoaMax: boolean = false
	fileuploadpoaMin: boolean = false
	fileuploadpoazMax: boolean = false 
	fileuploadpoazMin: boolean = false
	fileuploadpoazidMax: boolean = false 
	fileuploadpoazidMin: boolean = false
	fileuploadsebiMax: boolean = false
	fileuploadsebiMin: boolean = false
	fileuploadgstMax: boolean = false
	fileuploadgstMin: boolean = false
	fileuploadotherMax: boolean = false
	fileuploadotherMin: boolean = false
	isPMAdress:boolean=false;
	isAdress:boolean=false;
	myfilepoimyfilepoi: any[] = []; 
	myfilepoi: any[] = [];
	myfilepoa: any[] = [];
	myfilepoaz: any[] = [];
	myfilepoazid: any[] = [];
	myfilesebi: any[] = [];
	myfilegst: any[] = [];
	myfileother: any[] = [];
	//crtrPE:any;
	//crtrTM:any;
	//crtrTA:any;
	Address: any
	selectedClass: any
	crtr: any 


	get f() { return this.entityForm.controls; }

	indCategories: indCategory[] = [
		{ value: 'G', viewValue: 'Government' },
		{ value: 'P', viewValue: 'Private Ltd Company' },
		{ value: 'S', viewValue: 'SEBI' },
		{ value: 'U', viewValue: 'Public Limited Company' },
		{ value: 'O', viewValue: 'Individual' },
		{ value: 'O', viewValue: 'Sole Proprietorship' },
		{ value: 'O', viewValue: 'Partnership Firm' },
		{ value: 'O', viewValue: 'Limited Liability Partnership' },
		{ value: 'O', viewValue: 'Trust, Association, Society, Club' },
		{ value: 'O', viewValue: 'Others' },
	];
	
	telelistitems: telelistitem[] = [
		{ value: 'Scrubbing Service & Delivery Function', viewValue: 'Scrubbing Service & Delivery Function' },
		{ value: 'Only Scrubbing Service', viewValue: 'Only Scrubbing Service' },
		{ value: 'Only Delivery Function', viewValue: 'Only Delivery Function' },
	];

	nonGovSectorListItems: nonGovSectorList[] = [
		{ value: 'Textile Industry', viewValue: 'Textile Industry' },
		{ value: 'Food Processing Industry', viewValue: 'Food Processing Industry' },
		{ value: 'Chemical Industry', viewValue: 'Chemical Industry' },
		{ value: 'Travel and Tours', viewValue: 'Travel and Tours' },
		{ value: 'Ecommerce', viewValue: 'Ecommerce' },
		{ value: 'Automobile', viewValue: 'Automobile' },
		{ value: 'Construction material', viewValue: 'Construction material' },
		{ value: 'Real estate', viewValue: 'Real estate' },
		{ value: 'Health care', viewValue: 'Health care' },
		{ value: 'Education', viewValue: 'Education' },
		{ value: 'IT &Software Industry', viewValue: 'IT &Software Industry' },
		{ value: 'BPO', viewValue: 'BPO' },
		{ value: 'Entertainment', viewValue: 'Entertainment' },
		{ value: 'Investment Broker', viewValue: 'Investment Broker' },
		{ value: 'Financial Services/ Institutions', viewValue: 'Financial Services/ Institutions' },
		{ value: 'Others', viewValue: 'Others' }

	];

	//country
	selectedCountrylist: selectedCountry[] = [
		{ id: 'India', name: 'India' }
	];

	//states
	selectedStatelist: selectedState[] = [
		{ id: 'Andhra Pradesh', country_id: 'India', name: 'Andhra Pradesh' },
		{ id: 'Telagana', country_id: 'India', name: 'Telagana' },
		{ id: 'Karnataka', country_id: 'India', name: 'Karnataka' },
	];

	//city
	selectedCitylist: selectedCity[] = [
		{ id: 'Anantapur', state_id: 'Andhra Pradesh', name: 'Anantapur' },
		{ id: 'Chittoor', state_id: 'Andhra Pradesh', name: 'Chittoor' },
		{ id: 'Hyderabad', state_id: 'Telagana', name: 'Hyderabad' },
		{ id: 'Kariminagar', state_id: 'Telagana', name: 'Kariminagar' },
		{ id: 'Bengalore Urban', state_id: 'Karnataka', name: 'Bengalore Urban' },
		{ id: 'Bengalore Rural', state_id: 'Karnataka', name: 'Bengalore Rural' }
	];

	//poalist 
	poalistitems: poalist[] = [
		{ value: 'Firm registration certificate/MSME/UAM/ COI/ COR', viewValue: 'Firm registration certificate/MSME/UAM/ COI/ COR' },
		{ value: 'Shop Establishment/ Trade License/Labor Registration', viewValue: 'Shop Establishment/ Trade License/Labor Registration' },
		{ value: 'Power/ Telephone bill (<3 months)', viewValue: 'Power/ Telephone bill (<3 months)' },
		{ value: 'Others', viewValue: 'Others' }
	];

	ngOnInit() {
		this.entityForm = this.fb.group({ 
			EClass_PE: ['',],
			EClass_TM: ['',],
			EClass_TA: ['',],
			industry_category: ['',],
			Organization: ['', [Validators.required,Validators.pattern('^(?! ).*(?<! )$')]],
			pantanno: ['',],
			email: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,10}$')]], 
			mobileno: ['', [Validators.required, Validators.pattern("[1-9][0-9]{9}"), Validators.minLength(10), Validators.maxLength(10)]], 
			auth_signature: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(30)]],
			//gstid: ['', [Validators.pattern(/^(([0-9]){2}[a-zA-Z]{5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([zZ]){1}([a-zA-Z0-9]){1})*$/), Validators.minLength(15), Validators.maxLength(15)]],
			gstid: ['', [Validators.pattern(/^(([0-9]){2}[a-zA-Z]{4,5}([0-9]){4,5}([a-zA-Z]){1}([0-9]){1}([a-zA-Z0-9]){1}([a-zA-Z0-9]){1})*$/), Validators.minLength(15), Validators.maxLength(15)]],
			address1: ['', [Validators.required,Validators.pattern(/^[A-Za-z0-9,./_:-]+(?: +[A-Za-z0-9,./_:-]+)*$/), Validators.minLength(5), Validators.maxLength(100)]],
			address2: ['', [Validators.required,Validators.pattern(/^[A-Za-z0-9,./_:-]+(?: +[A-Za-z0-9,./_:-]+)*$/), Validators.minLength(5), Validators.maxLength(100)]],
			dltAddress: ['',], 
			landmark: ['', ], 
			selectedCountry: ['', [Validators.required]],
			selectedState: ['', [Validators.required]],
			selectedCity: ['', [Validators.required]],
			pincode: ['', [Validators.required, Validators.pattern(/^[1-9][0-9]{5}$/), Validators.minLength(6), Validators.maxLength(6)]],
			industry_types: [''],
			telemarket_sector: ['', [Validators.required]],
			poilist: ['',],
			selectpoi: [{value:'',disabled:true}, [Validators.required]],
			poazlist: ['',],
			selectpoaz: [{value:'',disabled:true}],
			poazidlist: ['',],
			selectpoazid: [{value:'',disabled:true}],
			selectpoa: ['', [Validators.required]],
			otherdocname: ['', [Validators.minLength(3), Validators.maxLength(50)]],
			confirmgstid: ['', [Validators.minLength(15), Validators.maxLength(15)]], 
			others_text: ['',],
			others_sector: ['', ],
			others_indType: ['', ], 
			fileuploadpoi: ['',], 
			fileuploadpoa: ['', [Validators.required]],   
			fileuploadpoaz: ['', [Validators.required]],  
			fileuploadpoazid: ['', [Validators.required]], 
			fileuploadgst: ['',], 
			fileuploadother: ['',],
			fileuploadsebi: ['',],
			//entityId: ['',],
			urn: ['',],
			TM_Type: ['',],   
			poiType: ['', [Validators.required]],
			Pancard: ['',],
			Entity_Ref_No: ['',],
			
		},{
				validator: MustMatch('gstid', 'confirmgstid')
			})  
		let data = {
			urn: this.UrnFromURL
		}
		this.es.getDetailsFromURN(data)
			.subscribe(r => {
				this.entityForm.controls['EClass_PE'].setValue(r.Entity_Class);
				this.entityForm.get('EClass_PE').disable();

				this.selectedClass = r.Entity_Class
				if(r.E_Org_Type == 'G'){
					this.hideSector=true;
					this.entityForm.controls['telemarket_sector'].clearValidators();
					this.entityForm.controls['telemarket_sector'].setValidators([Validators.nullValidator]);
					this.entityForm.controls['telemarket_sector'].updateValueAndValidity();
				}
				else{
				   this.hideSector=false;
				   this.entityForm.controls['telemarket_sector'].clearValidators();
				   this.entityForm.controls['telemarket_sector'].setValidators([Validators.required]);
				   this.entityForm.controls['telemarket_sector'].updateValueAndValidity();
				}

				this.Address = r.Entity_Addr
				
				this.crtr = r.Entity_Creator 
				
				this.Registered_Operator = r.Registered_Operator  
				if (r.Entity_Status == "A") {
					this.$modal.errorModal({
						title: 'Principal Entity / Telemarketer/Aggregator registration',
						msg: 'This URN is already approved by registrar!'
					})

				} else if (r.Entity_Status == "C") {
					this.$modal.errorModal({
						title: 'Principal Entity / Telemarketer/Aggregator registration',
						msg: 'This URN is pending for registrar approval!'
					})

				} else if (r.Entity_Status == "P") {
					this.$modal.errorModal({
						title: 'Principal Entity / Telemarketer/Aggregator registration',
						msg: 'This URN is sent for modifications by registrar!'
					})

				} else if (r.Entity_Status == "R") {
					this.$modal.errorModal({
						title: 'Principal Entity / Telemarketer/Aggregator registration',
						msg: 'This URN is rejected by registrar!'
					})

				} else if (r.Entity_Status == "I") {  
					this.showSumbit = true
					
					if (r.Entity_Class == "TM") { 
						this.teledroplist = true
						this.entityForm.controls['TM_Type'].setValidators([Validators.required])
						this.entityForm.controls['TM_Type'].updateValueAndValidity()
					}
					
					if (r.POI_Type == "PAN")
						this.showPAN = true;
					else
						this.showTAN = true; 
					this.entityForm.controls['selectpoa'].setValue(r.POI_Type) 
					this.entityForm.controls['poiType'].setValue(r.POI_Type)
					this.entityForm.controls['Pancard'].setValue(r.POI)
					this.entityForm.controls['Organization'].setValue(r.E_Org_Name) 
					if(r.Entity_Creator != "tata") {
						this.entityForm.controls['Organization'].disable()
						this.isAdress = true
						this.entityForm.controls['dltAddress'].setValue(this.Address) 
					}
					this.entityForm.controls['email'].setValue(r.Entity_EmailID)
					this.entityForm.controls['mobileno'].setValue(r.Entity_Mobile_No)
					this.entityForm.controls['urn'].setValue(this.UrnFromURL)
					this.entityForm.controls['industry_category'].setValue(r.E_Org_Type)
					this.entityForm.controls['selectpoi'].setValue(r.POI_Type);
					this.POItype=r.POI_Type;
					this.entityForm.controls['otherdocname'].setValue("") 
					this.industryCategory = r.E_Org_Type
					this.entityForm.controls['gstid'].setValue("")
					this.entityForm.controls['confirmgstid'].setValue("") 

					if (this.industryCategory == "G") { 
						this.poilistitems = [
							{ value: 'PAN', viewValue: 'PAN' },
							{ value: 'TAN', viewValue: 'TAN' }
						];
						this.indListItems = [
							{ value: 'Banking', viewValue: 'Banking' },
							{ value: 'Investment Broker (SEBI)', viewValue: 'Investment Broker (SEBI)' },
							{ value: 'Education', viewValue: 'Education' },
							{ value: 'Emergency Services', viewValue: 'Emergency Services' },
							{ value: 'Healthcare', viewValue: 'Healthcare' },
							{ value: 'Safety', viewValue: 'Safety' },
							{ value: 'Environmental Protection', viewValue: 'Environmental Protection' },
							{ value: 'Law & Order', viewValue: 'Law & Order' },
							{ value: 'Consumer Protection', viewValue: 'Consumer Protection' },
							{ value: 'Others', viewValue: 'Others' },
						]
					} else {
						this.poilistitems = [
							{ value: 'PAN', viewValue: 'PAN' },
						];
						this.indListItems = [
							{ value: 'Private Limited Company', viewValue: 'Private Limited Company' },
							{ value: 'Public Limited Company', viewValue: 'Public Limited Company' },
							{ value: 'Cooperative', viewValue: 'Cooperative' },
							{ value: 'Franchise', viewValue: 'Franchise' },
							{ value: 'NGO', viewValue: 'NGO' },
							{ value: 'Investments', viewValue: 'Investments' },
							{ value: 'Investment Broker (SEBI)', viewValue: 'Investment Broker (SEBI)' },
							{ value: 'Sole Proprietorship', viewValue: 'Sole Proprietorship' },
							{ value: 'Partnership', viewValue: 'Partnership' },
							{ value: 'Banking', viewValue: 'Banking' },
							{ value: 'Insurance', viewValue: 'Insurance' },
							{ value: 'Political Party', viewValue: 'Political Party' },
							{ value: 'Others', viewValue: 'Others' }
						]
					}
					if (this.industryCategory == "S") {
						this.isSEBI = true
						this.entityForm.controls['fileuploadsebi'].setValidators([Validators.required])
						this.entityForm.controls['fileuploadsebi'].updateValueAndValidity() 
					}
					if (r.Entity_POI_Doc != "" && r.Entity_POI_Doc != undefined) { 
						this.entityForm.controls['fileuploadpoi'].disable();
						this.Entity_POI_Doc = r.Entity_POI_Doc.substring(r.Entity_POI_Doc.indexOf('.') + 1)
					  } else {
						  this.Entity_POI_Doc = ""
					  }
					  
					  if (r.Entity_POA_Doc != "" && r.Entity_POA_Doc != undefined) {
						this.entityForm.controls['fileuploadpoa'].disable(); 
						this.Entity_POA_Doc = r.Entity_POA_Doc.substring(r.Entity_POA_Doc.indexOf('.') + 1)
					  } else {
						  this.Entity_POA_Doc = ""
					  }
					  
					  if (r.Entity_SEBI_Doc != "" && r.Entity_SEBI_Doc != undefined) { 
						this.entityForm.controls['fileuploadsebi'].disable();
						this.Entity_SEBI_Doc = r.Entity_SEBI_Doc.substring(r.Entity_SEBI_Doc.indexOf('.') + 1)
					  } else {
						  this.Entity_SEBI_Doc = ""
					  }
		  
					  if (r.Entity_GST_Doc != "" && r.Entity_GST_Doc != undefined) {  
						this.entityForm.controls['fileuploadgst'].disable();
						this.Entity_GST_Doc = r.Entity_GST_Doc.substring(r.Entity_GST_Doc.indexOf('.') + 1)
					  } else {
						  this.Entity_GST_Doc = ""
					  }
					  
					  if (r.Entity_POAZ_Doc != "" && r.Entity_POAZ_Doc != undefined) { 
						this.entityForm.controls['fileuploadpoaz'].disable();
						this.Entity_POAZ_Doc = r.Entity_POAZ_Doc.substring(r.Entity_POAZ_Doc.indexOf('.') + 1)
					  } else {
						  this.Entity_POAZ_Doc = ""
					  }
					  if (r.Entity_POAZID_Doc != "" && r.Entity_POAZID_Doc != undefined) { 
						this.entityForm.controls['fileuploadpoazid'].disable();
						this.Entity_POAZID_Doc = r.Entity_POAZID_Doc.substring(r.Entity_POAZID_Doc.indexOf('.') + 1)
					  } else {
						  this.Entity_POAZID_Doc = ""
					  }
					if (r.Entity_Other_Doc != "" && r.Entity_Other_Doc != undefined) {
						this.entityForm.controls['fileuploadother'].disable();
						this.Entity_Other_Doc = r.Entity_Other_Doc.substring(r.Entity_Other_Doc.indexOf('.') + 1)
					  } else {
						  this.Entity_Other_Doc = ""
					  }
					  if (r.Entity_Other_Doc1 != "" && r.Entity_Other_Doc1 != undefined) {
						this.myfileotherDuplicate.push({name: this.Entity_Other_Doc, value: this.Entity_Other_Doc})
						this.Entity_Other_Doc1 = r.Entity_Other_Doc1.substring(r.Entity_Other_Doc1.indexOf('.') + 1)
					  } else {
						  this.Entity_Other_Doc1 = ""
					  }
					  if(this.myfileotherDuplicate.length == 2){
						  this.entityForm.controls['fileuploadother'].disable();
		  
				  }
					
					
				}
			})
			
	}//end of oninit
	
	downloadKYCyprocess(){
		let link =document.createElement('a');
		link.setAttribute('type', 'hidden');
		link.href = '../../../../../assets/KYC Policy.pdf';
		link.download = 'Privacy KYC Policy Process';
		document.body.appendChild(link);
		link.click();
		link.remove();
	  } 


	//entity classification on change event fire 
	
	resetOther(id){
		
		this.myfilesother = this.myfilesother.filter(function( obj ) {
			return obj.name !== id.name;
		})	
		this.myfileotherDuplicate = this.myfileotherDuplicate.filter(function( obj ) {
			return obj.name !== id.name;
		})		


	}
	reset(id)
    
    {
      this.entityForm.controls[id].reset();
	 // this.btndisabled = true;
	 if(id == "fileuploadpoi"){
		this.myfilespoi = [];
	 }
	 if(id == "fileuploadpoa"){
		this.myfilespoa = [];
	 }
	 if(id == "fileuploadgst"){
		this.myfilesgst = [];
	 }
	 if(id == "fileuploadsebi"){
		this.myfilessebi = [];
	 }
	 if(id == "fileuploadpoaz"){
		this.myfilespoaz = [];
	 }
	 if(id == "fileuploadpoazid"){
		this.myfilespoazid = [];
	 }
	 if(id == "fileuploadother"){
		this.myfilesother = [];
	 }
	 
	 }
 
	deleteDocument(file1, entityId, file_Hash_KYC_Doc, filetype, formcontrolname) {  
						
						if(file_Hash_KYC_Doc == "Entity_POI_Doc") {
							this.Entity_POI_Doc = ""
							
						} else if (file_Hash_KYC_Doc == "Entity_POA_Doc") {
							this.Entity_POA_Doc = "" 
						
						} else if (file_Hash_KYC_Doc == "Entity_GST_Doc") {
							this.Entity_GST_Doc = ""
							
						} else if (file_Hash_KYC_Doc == "Entity_SEBI_Doc") {
							this.Entity_SEBI_Doc = ""
							
						}  else if (file_Hash_KYC_Doc == "Entity_POAZ_Doc") {
							this.Entity_POAZ_Doc = "" 
						
						}else if (file_Hash_KYC_Doc == "Entity_POAZID_Doc") {
							this.Entity_POAZID_Doc = "" 
						
						}else if (file_Hash_KYC_Doc == "Entity_Other_Doc") {
							this.myfileotherDuplicate.splice(file1,1)

							this.Entity_Other_Doc = ""
						}else if (file_Hash_KYC_Doc == "Entity_Other_Doc1") {
							this.myfileotherDuplicate.splice(file1,1)
	 
							this.Entity_Other_Doc1 = ""
						}
					
	}

	
	focusOutFunction(address1){

		if(address1.value === undefined || ''){
			return true;
		}
		var numbers = /^[0-9]+$/;
		let adrsValue=address1.value.match(numbers);
		if(address1.title === 'address1'){
			if(adrsValue){
				this.isNumCheckadres1=true;
			}else{
			   this.isNumCheckadres1=false;

			}
		}
	    if(address1.title === 'address2'){
		   if(adrsValue){
			   this.isNumCheckadres2=true;
		   }else{
			  this.isNumCheckadres2=false;
		   }
		}
		   if(address1.title === 'orgname'){
			if(adrsValue){
			this.isNumOrgName=true;
		}else{
			this.isNumOrgName=false;
		}
	}
	   
   
   }; 
   
	//country state city
	onChangeCountry() {
		this.newlistitems = [];
		
		this.es.getAllStates(this.selectedCountryId)
		.subscribe(r => {
		

			this.newlistitems=r

		})

	}

	//newstatelistitems
	onChangeState() {
		this.newstatelistitems = [];
		
		this.es.getCitiesByStateName(this.selectedStateId)
		.subscribe(r => {
			this.newstatelistitems=r
		
		})

	}

	onChangePOI(event) { 
		this.PiList = event.value;
		if (event.value == "PAN") {
			this.showPAN = true;
			this.showTAN = false;
		}
		else if (event.value == "TAN") {
			this.showTAN = true;
			this.showPAN = false;
 		}
		this.entityForm.controls['fileuploadpoi'].setValidators([Validators.required])
		this.entityForm.controls['fileuploadpoi'].updateValueAndValidity()
	}

	onChangepoa(event) {
		this.poashow = true
		this.entityForm.controls['fileuploadpoa'].setValidators([Validators.required])
		this.entityForm.controls['fileuploadpoa'].updateValueAndValidity()
	}

	onChangepoaz(event) {
		this.poazshow = true
		this.entityForm.controls['fileuploadpoaz'].setValidators([Validators.required])
		this.entityForm.controls['fileuploadpoaz'].updateValueAndValidity()
	}
	onChangepoazid(event) {
		this.poazidshow = true
		this.entityForm.controls['fileuploadpoazid'].setValidators([Validators.required])
		this.entityForm.controls['fileuploadpoazid'].updateValueAndValidity()
	}
	
	onChangeIndType(event) {
		if (event.value == "Others") {
			this.otherindtypeshow = true;
			this.entityForm.controls['others_indType'].setValidators([Validators.pattern(/^[A-Za-z,./_:-]+(?: +[A-Za-z,./_:-]+)*$/), Validators.required, Validators.minLength(3), Validators.maxLength(50)])   
		}
		else {
			this.otherindtypeshow = false;
			this.entityForm.controls['others_indType'].clearValidators()
			this.entityForm.controls['others_indType'].updateValueAndValidity() 
		}
		
		if(event.value == "Investment Broker (SEBI)" || this.industryCategory == "S") {
			this.isSEBI = true
			this.entityForm.controls['fileuploadsebi'].setValidators([Validators.required])
			this.entityForm.controls['fileuploadsebi'].updateValueAndValidity()
		} 
		else {
			this.isSEBI = false
			this.entityForm.controls['fileuploadsebi'].clearValidators()
			this.entityForm.controls['fileuploadsebi'].updateValueAndValidity() 
		}
	}


	isSpecindtype:boolean=false;
	isSpecOther:boolean=false;
	isSpecsector:boolean=false;
   noWhitespaceValidator(control) {
	if (control.value.startsWith(' ')) {
		if(control.id== 'others_indType'){
		this.isSpecindtype=true;
		}else if(control.id== 'others_sector'){
			this.isSpecsector=true;
		}
		else if(control.id== 'otherdocname'){
			this.isSpecOther=true;
		}
	  }else
	  if (control.value.endsWith(' ')) {
		if(control.id== 'others_indType'){
			this.isSpecindtype=true;
			}else if(control.id== 'others_sector'){
				this.isSpecsector=true;
			}
			else if(control.id== 'otherdocname'){
				this.isSpecOther=true;
			}
		
	  }else{
		this.isSpecindtype=false;
		this.isSpecsector=false;
		this.isSpecOther=false;

	  }
	
	
}

omit_special_char(e) {

	var k;
	document.all ? k = e.keyCode : k = e.which;
	return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k == 109) || (k == 189)|| (k == 95) || (k == 45) || (k >= 48 && k <= 57));
}

	
	onchangesector(event) {
		if (event.value == "Others") {
			this.othersectorshow = true;
			this.entityForm.controls['others_sector'].setValidators([Validators.pattern(/^[A-Za-z,./_:-]+(?: +[A-Za-z,./_:-]+)*$/), Validators.required, Validators.minLength(3), Validators.maxLength(50)]) 
		}
		else {
			this.othersectorshow = false;
			this.entityForm.controls['others_sector'].clearValidators()
			this.entityForm.controls['others_sector'].updateValueAndValidity()   
		}
	}

	isInArray(array, word) {
		return array.indexOf(word.toLowerCase()) > -1;
	  }
	  
    onChangeFileUpload(event, id) {
      var file = event.target.files[0];
      this.photoName = file.name;
      var allowedExtensions = ["jpg", "jpeg", "png", "JPG", "JPEG", "JFIF", "BMP", "SVG", "pdf"] //remove docx        
      this.fileExtension = this.photoName.split('.').pop().toLowerCase();
      let fileNameArr = this.photoName.split('.')
      console.log("fileNameArr ",fileNameArr)
        if(fileNameArr.length>2){
          console.log("hereeee 837")
          // this.fileDoubleExtensionError = true
          this.$modal.errorModal({
            title: 'Principal Entity/Telemarketer/Aggregator registration',
            msg: 'File with double extension is not allowed!' 
          })
          if(id=="fileuploadpoi"|| id=="fileuploadpoa" || id=="fileuploadpoazid" || id == "fileuploadsebi" || id == "fileuploadgst" || id == "fileuploadpoaz"){
            this.reset(id)
          }else{
            this.reset(id)
          } 
        }else{
          if (this.isInArray(allowedExtensions, this.fileExtension)) {  
            this.fileExtensionError = false;
            
            if (id == "fileuploadpoi") { 
              
              if (file.size > 4242880) 
                this.fileuploadpoiMax = true 
              else
                this.fileuploadpoiMax = false
              if (file.size <= 0) 
                this.fileuploadpoiMin = true
              else
                this.fileuploadpoiMin = false
              
              this.poifileExtensionError = false;
              this.myfilespoi.push(event.target.files[0])
              
              
              
            } else if (id == "fileuploadpoa") {
              
              if (file.size > 4242880) 
                this.fileuploadpoaMax = true
              else
                this.fileuploadpoaMax = false
              
              if (file.size <= 0) 
                this.fileuploadpoaMin = true
              else
                this.fileuploadpoaMin = false
              
              this.poafileExtensionError = false;
              this.myfilespoa.push(event.target.files[0])
              
            } else if (id == "fileuploadpoazid") {
              
              if (file.size > 4242880) 
                this.fileuploadpoazidMax = true
              else
                this.fileuploadpoazidMax = false
              
              if (file.size <= 0) 
                this.fileuploadpoazidMin = true
              else
                this.fileuploadpoazidMin = false
              
              this.poazidfileExtensionError = false;
              this.myfilespoazid.push(event.target.files[0])
              
            } else if (id == "fileuploadsebi") {
              
              if (file.size > 4242880) 
                this.fileuploadsebiMax = true
              else
                this.fileuploadsebiMax = false
              
              if (file.size <= 0) 
                this.fileuploadsebiMin = true 
              else
                this.fileuploadsebiMin = false 
              
              this.sebifileExtensionError = false;
              this.myfilessebi.push(event.target.files[0])
              
            } else if (id == "fileuploadgst") {
              
              if (file.size > 4242880) 
                this.fileuploadgstMax = true
              else
                this.fileuploadgstMax = false
              
              if (file.size <= 0) 
                this.fileuploadgstMin = true  
              else
                this.fileuploadgstMin = false 
              
              this.gstfileExtensionError = false;
              this.myfilesgst.push(event.target.files[0]) 
              
            }  else if (id == "fileuploadpoaz") {
              
              if (file.size > 4242880) 
                this.fileuploadpoazMax = true
              else
                this.fileuploadpoazMax = false
              
              if (file.size <= 0) 
                this.fileuploadpoazMin = true
              else
                this.fileuploadpoazMin = false
              
              this.poazfileExtensionError = false;
              this.myfilespoaz.push(event.target.files[0])
              
            }else if (id == "fileuploadother") { 
              if(event.target.files.length>2){
                this.$modal.errorModal({
                  title: 'Principal Entity / Telemarketer/Aggregator registration',
                  msg: 'More Than Two Files cannot be Uploaded!' 
                }) 
                this.myfilesother=[];
                this.entityForm.controls['fileuploadother'].reset()
      
                return;
              }
              if(this.myfileotherDuplicate.length >= 2) {  
                this.$modal.errorModal({
                  title: 'Principal Entity / Telemarketer/Aggregator registration',
                  msg: 'More Than Two Files cannot be Uploaded!' 
                })
              } else {
                if (file.size > 4242880) 
                  this.fileuploadotherMax = true
                if (file.size <= 0) 
                  this.fileuploadotherMin = true 
                  this.myfileotherDuplicate.push(event.target.files[0])
      
                
                this.otherfileExtensionError = false;
                this.myfilesother.push(event.target.files[0]) 
                if(event.target.files[1]) {
                  this.myfilesother.push(event.target.files[1])  
                  this.myfileotherDuplicate.push(event.target.files[1])
       
                }
              } 
              this.entityForm.controls['fileuploadother'].reset()
            } 
            else {
            }
          } else {
            if (id == "fileuploadpoi") {
              this.poifileExtensionError = true;
              
            } else if (id == "fileuploadpoa") {
              this.poafileExtensionError = true;
              
            } else if (id == "fileuploadsebi") {
              this.sebifileExtensionError = true;
      
              
            } else if (id == "fileuploadgst") {
              this.gstfileExtensionError = true;
      
              
            } else if (id == "fileuploadpoaz") {
              this.poazfileExtensionError = true;
              
              } else if (id == "fileuploadpoazid") {
              this.poazidfileExtensionError = true;
              
              }else if (id == "fileuploadother") {
              this.otherfileExtensionError = true;
      
            }
          }
        }
    }
	
	changegstshow() {
		this.gstidinfo = this.entityForm.get("gstid").value;
		if (this.gstidinfo == "" || this.gstidinfo === undefined) { 
			this.gstdivinfoshow = false;
			this.entityForm.controls['confirmgstid'].setValue("")  
			this.entityForm.controls['confirmgstid'].clearValidators()
			this.entityForm.controls['confirmgstid'].updateValueAndValidity()
			this.entityForm.controls['fileuploadgst'].clearValidators()  
			this.entityForm.controls['fileuploadgst'].updateValueAndValidity() 
		}
		else {
			this.gstdivinfoshow = true;
			this.entityForm.controls['fileuploadgst'].setValidators([Validators.required]) 
			this.entityForm.controls['fileuploadgst'].updateValueAndValidity() 
			
			this.entityForm.controls['confirmgstid'].setValidators([Validators.required])
			this.entityForm.controls['confirmgstid'].updateValueAndValidity()   
		}
	}
	getvalidation(){
	//if(this.isAdress){
		this.entityForm.controls['address1'].setValue('');

		this.entityForm.controls['address1'].clearValidators();
		this.entityForm.controls['address1'].setValidators([Validators.nullValidator])
		this.entityForm.controls['address1'].updateValueAndValidity();

		this.entityForm.controls['address2'].setValue('');
		this.entityForm.controls['address2'].clearValidators();
		this.entityForm.controls['address2'].setValidators([Validators.nullValidator])
		this.entityForm.controls['address2'].updateValueAndValidity() 

		this.entityForm.controls['selectedCountry'].reset();
		this.entityForm.controls['selectedCountry'].clearValidators();
		this.entityForm.controls['selectedCountry'].setValidators([Validators.nullValidator])
		this.entityForm.controls['selectedCountry'].updateValueAndValidity() 

		this.entityForm.controls['selectedState'].reset();
		this.entityForm.controls['selectedState'].clearValidators();
		this.entityForm.controls['selectedState'].setValidators([Validators.nullValidator])
		this.entityForm.controls['selectedState'].updateValueAndValidity() 
		this.entityForm.controls['selectedCity'].reset();

		this.entityForm.controls['selectedCity'].clearValidators();
		this.entityForm.controls['selectedCity'].setValidators([Validators.nullValidator])
		this.entityForm.controls['selectedCity'].updateValueAndValidity() 

		this.entityForm.controls['pincode'].setValue('');
		this.entityForm.controls['pincode'].clearValidators();
		this.entityForm.controls['pincode'].setValidators([Validators.nullValidator])
		this.entityForm.controls['pincode'].updateValueAndValidity() 
		//}
	}
	KYCyprocess(){
		let link =document.createElement('a');
		link.setAttribute('type', 'hidden');
		link.href = '../../../../../assets/KYC Policy.pdf';
		link.download = 'Privacy KYC Policy Process';
		document.body.appendChild(link);
		link.click();
		link.remove();
	  }

	onSubmit() {
		//this.entityForm.get("selectpoi").enable();
		const entityForm: FormData = new FormData()
		
		if(this.selectedClass == "PE")
			entityForm.append('EClass_PE', "PE")
		if(this.selectedClass == "TM") 
			entityForm.append('EClass_TM', "TM")
		if(this.selectedClass == "TA")  
			entityForm.append('EClass_TA', "TA") 
		
		if(this.selectedClass == "TM")
			entityForm.append('TM_Type', this.entityForm.get("TM_Type").value)  
		else 
			entityForm.append('TM_Type', "")  
		
		entityForm.append('Entity_Ref_No', this.UrnFromURL)    
		entityForm.append('entityId', "")  
		entityForm.append('Common_ID', "")
		entityForm.append('industry_category', this.entityForm.get("industry_category").value) 
		entityForm.append('poiType', this.entityForm.get("poiType").value)
		entityForm.append('pantanno', this.entityForm.get("Pancard").value)
		entityForm.append('Organization', this.entityForm.get("Organization").value) 
		entityForm.append('email', this.entityForm.get("email").value)
		entityForm.append('mobileno', this.entityForm.get("mobileno").value)
		entityForm.append('authSignature', this.entityForm.get("auth_signature").value)
		entityForm.append('gstid', this.entityForm.get("gstid").value)
		entityForm.append('industry_type', this.entityForm.get("industry_types").value)
		entityForm.append('others_indType', this.entityForm.get("others_indType").value)
		entityForm.append('telemarket_sector', this.entityForm.get("telemarket_sector").value)
		entityForm.append('others_sector', this.entityForm.get("others_sector").value)
		
	
		let entityAddress = ""
		//if(this.entityForm.get("address1").value) {
		if(this.entityForm.get("address1").value && !(this.entityForm.get("dltAddress").value)) {
			entityAddress=this.entityForm.get("address1").value +", "+this.entityForm.get("address2").value+", "+this.entityForm.get("landmark").value+", "+this.entityForm.get("selectedCountry").value+", "+this.entityForm.get("selectedState").value+", "+this.entityForm.get("selectedCity").value+", "+this.entityForm.get("pincode").value
			entityForm.append('entityCreator', "tata") 
			
			entityForm.append('address1', this.entityForm.get("address1").value)
			entityForm.append('address2', this.entityForm.get("address2").value)
			entityForm.append('landmark', this.entityForm.get("landmark").value)
			entityForm.append('selectedCountry', this.entityForm.get("selectedCountry").value) 
			entityForm.append('selectedState', this.entityForm.get("selectedState").value)
			entityForm.append('selectedCity', this.entityForm.get("selectedCity").value) 
			entityForm.append('pincode', this.entityForm.get("pincode").value)
			
		} else if(this.entityForm.get("dltAddress").value) {
			entityAddress=this.entityForm.get("dltAddress").value
			entityForm.append('entityCreator', this.crtr);  
			//this.getvalidation();
			
			entityForm.append('address1', this.entityForm.get("address1").value)
			entityForm.append('address2', this.entityForm.get("address2").value)
			entityForm.append('landmark', this.entityForm.get("landmark").value)
			entityForm.append('selectedCountry', this.entityForm.get("selectedCountry").value) 
			entityForm.append('selectedState', this.entityForm.get("selectedState").value)
			entityForm.append('selectedCity', this.entityForm.get("selectedCity").value) 
			entityForm.append('pincode', this.entityForm.get("pincode").value)
		}  

		entityForm.append('entityAddress', entityAddress) 
		entityForm.append('selectpoi', this.entityForm.get("selectpoi").value)
		entityForm.append('selectpoa', this.entityForm.get("selectpoa").value)

		entityForm.append('otherdocname', this.entityForm.get("otherdocname").value)
		
		entityForm.append('fileuploadpoi', this.myfilespoi[0]) 
		entityForm.append('fileuploadpoa', this.myfilespoa[0])
		entityForm.append('fileuploadgst', this.myfilesgst[0])
		entityForm.append('fileuploadsebi', this.myfilessebi[0])
		entityForm.append('fileuploadpoaz', this.myfilespoaz[0])
		entityForm.append('fileuploadpoazid', this.myfilespoazid[0])
		entityForm.append('fileuploadother', this.myfilesother[0])
		entityForm.append('fileuploadother1', this.myfilesother[1])    
		
		entityForm.append('entityStatus', "C") 
		entityForm.append('Registered_Operator', this.Registered_Operator) 
		entityForm.append('Update_After_Approval', "N") 
		//entityForm.append('Registered_ID', this.Registered_ID) 		 
		entityForm.append('reqtype', "registration") //for edit/audit logs  

		if (this.entityForm.invalid) {
			let invalid = [];
			let controls = this.entityForm.controls;
			for (const name in controls) {
				if (controls[name].invalid) {
					if(name == "fileuploadpoa")
					{
						this.$modal.successModal({
							title: 'Principal Entity / Telemarketer/Aggregator registration',
							msg: 'Please upload Proof of Address (POA)'
						}) 
					}
					else if(name == "fileuploadpoi"){
						this.$modal.successModal({
							title: 'Principal Entity / Telemarketer/Aggregator registration',
							msg: 'Please upload Proof of Identity (POI)'
						}) 
					}
					else if(name == "fileuploadsebi"){
						this.$modal.successModal({
							title: 'Principal Entity / Telemarketer/Aggregator registration',
							msg: 'Please upload SEBI Document'
						}) 
					}else if(name == "fileuploadgst"){
							this.$modal.successModal({
								title: 'Principal Entity / Telemarketer/Aggregator registration',
								msg: 'Please upload GST Document'
							}) 
						}
						else if(name == "fileuploadpoaz"){
							this.$modal.successModal({
								title: 'Principal Entity / Telemarketer/Aggregator registration',
								msg: 'Please upload Proof of Authorization'
							}) 
						}
						else if(name == "fileuploadpoazid"){
							this.$modal.successModal({
								title: 'Principal Entity / Telemarketer/Aggregator registration',
								msg: 'Please upload Identity Proof of Authorized Signatory '
							}) 
						}
					

					invalid.push(name)
				}
			}
			return
		} 
		else if (this.poifileExtensionError || this.poafileExtensionError || this.poazfileExtensionError || this.poazidfileExtensionError || this.sebifileExtensionError || this.gstfileExtensionError || this.otherfileExtensionError ) { 
		 
			return;
		}
		else if (this.fileuploadpoiMax || this.fileuploadpoaMax || this.fileuploadpoazMax || this.fileuploadpoazidMax || this.fileuploadgstMax || this.fileuploadsebiMax || this.fileuploadotherMax ) { 
		 
			return;
		}

		else {
			this.modalRef = this.modalService.show(ModalPromptEntityComponent)
			this.modalRef.content.modalDataObj = {
			  title: "PE/TM/TA Verification",
			  //msg: "Your data sumbitted successfully. Would you like to complete registration process now?"
			  msg: "Please check if all the details in the request are correct & the corresponding KYC documents as per checklist have been uploaded",
			  btnYes: 'Yes',
			  btnNo: 'No'
			}
			this.modalRef.content.onClose.subscribe(result => {
			  this.returnedValue = result
			  console.log("results", result)
		
				if (this.returnedValue == true) {
			  
				
			this.entityForm.get("selectpoi").enable();
			this.es.TMPEentityUpdation(entityForm)
				.subscribe(r => {
					if (r.status == "success") {
						this.showSumbit = false
						this.$modal.successModal({
							title: 'Principal Entity/Telemarketer /Aggregator registration',
							// msg: 'You have successfully registered with TTL. We will notify you once your request gets approved!'+r.Entity_Ref_No
							msg: 'You have successfully raised the registration request. We will notify you through mail/sms once the same is actioned. Your URN no is '+r.Entity_Ref_No
						}) 
						this.router.navigateByUrl('/')
					}
					else {
						this.$modal.errorModal({ 
							title: 'Principal Entity/Telemarketer /Aggregator registration',
							msg: 'Error updating Entity Details!'
						})
					}
			})
		}
	})
}
	}
}//end of export